function setCookie(name: string, value: string, days: number): void {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
}

document.addEventListener('DOMContentLoaded', () => {
  const banner = document.querySelector<HTMLElement>('[data-cookie-consent]');
  const acceptButton = document.querySelector<HTMLButtonElement>('[data-cookie-consent-accept]');

  if (!banner || !acceptButton) return;

  acceptButton.addEventListener('click', () => {
    setCookie('cookie_consent', '1', 180);
    banner.style.transition = 'opacity 0.3s ease';
    banner.style.opacity = '0';
    banner.addEventListener(
      'transitionend',
      () => {
        banner.classList.add('hidden');
      },
      { once: true },
    );
  });
});
